import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import Button from 'yoda-core-components/lib/components/Button/Button';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import * as myListActions from 'yoda-account-components/lib/actions/MyListActions';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as SignInSliderActions from '../../actions/SignInSliderActions';
import * as styles from './CreateMyList.css';

const cx = classNames.bind(styles);

const config = {
    regex: {
        listName: /^.{4,24}$/,
    },
};

const getErrorMessage = (errorMessages, error) => {
    // default message
    let message = get(errorMessages, 'DEFAULT', '');
    const serviceErrorCode = error.errorCode;

    // if we have FE mapping to overrride message for errorCode
    /* istanbul ignore next */
    if (errorMessages && errorMessages[serviceErrorCode]) {
        message = errorMessages[serviceErrorCode];
    } else if (error.errorMessage) {
        // Otherwise Error from Service
        message = error.errorMessage;
    }
    // If both doesnt match, default message will be taken
    return message;
};

/* istanbul ignore next */
const redirectToList = (id) => {
    const url = `/mylist?id=${id}`;
    window.location.href = url;
};

export function CreateMyList(props) {
    const [myListNameSubmit, setMyListNameSubmit] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [myListNameLocal, setMyListNameLocal] = useState('');

    const { userState } = props;
    const { errorMessages } = props;
    const { camNavMyList } = props;
    const { actions } = props;
    const isLoading = get(camNavMyList, 'isLoading', false);
    const myListName = get(camNavMyList, 'myListName', '');
    const successResponse = get(camNavMyList, 'myList.response');
    const myListFailure = get(camNavMyList, 'myListError.response');

    const { messagesTexts } = props;

    const createListSubmit = (event) => {
        event.preventDefault();
        if (userState === '0' || userState === '2') {
            actions.openSignInSlider();
        } else {
            const value = event.target.myListName.value.trim();
            if (!value) {
                setErrorMessage(messagesTexts.emptyListNameMessage);
                return;
            }
            if (!config.regex.listName.test(value)) {
                setErrorMessage(messagesTexts.invalidListNameMessage);
                return;
            }
            setMyListNameSubmit(value);
        }
    };

    const handleMyListNameChange = (e) => {
        const value = e.target.value.trim();
        if (!config.regex.listName.test(value)) {
            /* istanbul ignore else */
            if (value.length > 24) {
                setErrorMessage(messagesTexts.invalidListNameMessage);
                return;
            }
        }
        if (errorMessage.length > 0) {
            setErrorMessage('');
        }
        setMyListNameLocal(e.target.value);
    };
    useEffect(() => {
        /* istanbul ignore next */
        if (myListFailure) {
            const message = getErrorMessage(errorMessages, myListFailure);
            setErrorMessage(message);
        } else if (successResponse) {
            redirectToList(successResponse.id);
        }
    }, [errorMessages, myListFailure, successResponse]);

    useEffect(() => {
        if (myListNameSubmit.length > 0) {
            /* istanbul ignore next */
            if (userState === '0' || userState === '2') {
                actions.addMyListName({ myListName: myListNameSubmit });
                // Condition to check enableSignInSlider
                actions.openSignInSlider();
            } else if (userState === '1' && !isLoading) {
                actions.createMyList({ name: myListNameSubmit });
            }
            setMyListNameSubmit('');
        }
    }, [isLoading, myListNameSubmit, userState, actions]);

    if (myListName && myListName.length > 0 && myListNameSubmit.length === 0 && userState === '1') {
        setMyListNameLocal(myListName);
        setMyListNameSubmit(myListName);
        actions.removeMyListName();
    }
    const loadingAutomationId = 'loadingAutomationId-1';
    const keepOverlay = true;
    const showErr = errorMessage.length > 0;
    return (
        <>
            <form onSubmit={createListSubmit} noValidate>
                <fieldset className={dt(['flex', 'flex-col'])}>
                    <div
                        className={`${cx('formGroup')} ${dt([
                            'h-10',
                            'text-center',
                            'flex',
                            'justify-center',
                        ])}`}
                    >
                        <input
                            id="myListName"
                            name="addListName"
                            onChange={handleMyListNameChange}
                            value={myListNameLocal}
                            type="text"
                            className={`${cx('input')} ${dt([
                                'w-[165px]',
                                'text-gray-60',
                                'font-sans',
                                'text-normal',
                                'py-0',
                                'px-4',
                                'border',
                                'border-solid',
                                'border-gray-15',
                                'outline-none',
                                'leading-6',
                                'rounded-tl-lg',
                                'rounded-tr-none',
                                'rounded-br-none',
                                'rounded-bl-lg',
                                'md:w-[165px]',
                                'disabled:opacity-70',
                            ])}`}
                            placeholder="Create New List..."
                        />
                        <Button
                            className={`${cx('createSubmitButton')} ${dt([
                                'relative',
                                '!rounded-tr-lg',
                                '!rounded-br-lg',
                                '!rounded-bl-none',
                                '!rounded-tl-none',
                                '!bg-brand-red',
                                'min-w-[72px]',
                                'font-sans',
                                'text-base',
                                'font-bold',
                                'leading-6',
                                'text-center',
                                'text-white',
                                'disabled:pointer-events-none',
                            ])}`}
                            size="Md"
                            type="submit"
                        >
                            Add
                        </Button>
                    </div>
                </fieldset>
            </form>
            {isLoading && <Loader automationId={loadingAutomationId} keepOverlay={keepOverlay} />}
            {showErr && (
                <div className={cx('message')}>
                    <MessageBox
                        showIcon={false}
                        showMessage={showErr}
                        type="error"
                        title={errorMessage}
                        theme={cx('messageBoxTheme')}
                        level="inline"
                        contentClassName={cx('listMsgBox')}
                    />
                </div>
            )}
        </>
    );
}

CreateMyList.propTypes = {
    userState: PropTypes.objectOf.isRequired,
    errorMessages: PropTypes.objectOf.isRequired,
    camNavMyList: PropTypes.objectOf.isRequired,
    messagesTexts: PropTypes.objectOf.isRequired,
    actions: PropTypes.objectOf.isRequired,
};

const mapStateToProps = (state) => ({
    userState: get(state, 'accounts.userProfile.userState', '0'),
    errorMessages: get(state, 'context.preferences.myListing.errorMessages'),
    camNavMyList: state.camNavMyList,
    messagesTexts: get(state, 'context.messagesTexts.copyList', {}),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...myListActions, ...SignInSliderActions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateMyList);
